import { render, staticRenderFns } from "./ConformityChart.vue?vue&type=template&id=56988c53&scoped=true&"
import script from "./ConformityChart.vue?vue&type=script&lang=js&"
export * from "./ConformityChart.vue?vue&type=script&lang=js&"
import style0 from "./ConformityChart.vue?vue&type=style&index=0&id=56988c53&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56988c53",
  null
  
)

export default component.exports